import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { Card } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 24px;
  text-align: center;

  @media screen and (max-width: 768px) {
    padding: 0px;
  }
`;

export const Avatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50% !important;
  margin: 20px auto 10px;
  display: block;

  @media (min-width: 1440px) {
    min-width: 120px;
    min-height: 120px;
    max-width: 120px;
    max-height: 120px;
  }

  @media (max-width: 1441px) {
    min-width: 60px;
    min-height: 60px;
    max-width: 100px;
    max-height: 100px;
  }
`;

export const CardContent = styled.div`
  text-align: center;
  color: #1a295a;
  font-size: 16px;

  .name {
    display: block;
    font-weight: ${FONT_WEIGHT.bold};
  }

  .role {
    display: block;
    font-weight: ${FONT_WEIGHT.light};
  }
`;

export const TeamCard = styled(Card)`
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease;
  width: 100%;
  background: #f8f9fa;

  &:hover {
    transform: translateY(-5px);
  }

  .ant-card-body {
    padding: 16px;
  }
`;

export const TeamListWrapper = styled.div<{ columns: number }>`
  display: grid;
  grid-template-columns: repeat(${(p) => p.columns}, 1fr);
  gap: 8px;
  justify-items: center;
  margin-bottom: 8px;

  @media screen and (min-width: 1024px) and (max-width: 1440px) {
    &.team-list-wrapper-6 {
      flex-wrap: wrap;
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    }
  }

  @media (max-width: 1025px) {
    &.team-list-wrapper-4 {
      grid-template-columns: repeat(auto-fill, minmax(49%, 1fr));
    }
    &.team-list-wrapper-5 {
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    }
    &.team-list-wrapper-6 {
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    }
  }

  @media (max-width: 768px) {
    &.team-list-wrapper-4 {
      grid-template-columns: repeat(auto-fill, minmax(50%, 1fr));
    }
    &.team-list-wrapper-5 {
      grid-template-columns: repeat(auto-fill, minmax(50%, 1fr));
    }
    &.team-list-wrapper-6 {
      grid-template-columns: repeat(auto-fill, minmax(50%, 1fr));
    }
  }
`;

export const AllTeamImage = styled.img`
  max-width: 100%;
  margin-block-start: 10px;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
`;
